// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Ativo',
    active_switch_description: 'Ao desativar a propriedade Ativo do usuário, você faz duas coisas: libera uma licença para outro usuário e torna o usuário inativo invisível em todos os lugares do sistema, exceto na página Usuários.',
    add_user: 'Adicionar usuário',
    apply: 'Aplicar',
    assign: 'Adicionar',
    assigned_activities_menu_title: 'Atividades atribuídas',
    can_login: 'Pode fazer login',
    can_login_switch_description: 'Ao desativar Pode fazer login, você apenas nega ao usuário o acesso ao sistema. O usuário ainda pode ser membro ou destinatário de projeto. Esta ação também liberará uma licença, se necessário.',
    cancel: 'Cancelar',
    CanDenyLogin_User_DenyLoginYourself: 'Você não pode desativar Pode fazer login para si mesmo.',
    CanDenyLogin_User_LastAdministrator: 'Você não pode desativar Pode fazer login para um usuário que é o único administrador no sistema.',
    CanDisable_User_DisableYourself: 'Você não pode desativar Ativo para si mesmo.',
    CanDisable_User_LastAdministrator: 'Você não pode desativar Ativo para um usuário que é o único administrador no sistema.',
    cant_delete_user: 'O usuário \"{0}\" não pode ser excluído',
    cant_login: 'Não é possível fazer login',
    change_password: 'Alterar senha',
    close: 'Fechar',
    convert_title: 'Converter',
    convert_to_regular: 'Converter para usuário regular',
    convert_to_regular_title: 'Converter {0} para um usuário regular com a função:',
    convert_to_regular_title_with_job_role: 'Converter {0} para um usuário regular com a função de cargo:',
    deactivate: 'Alterar status',
    deactivateTitle: 'Alterar status do usuário para Inativo',
    delete: 'Excluir',
    delete_confirm: 'Excluir este usuário?',
    delete_skill_title: 'Excluir habilidade',
    delete_team_title: 'Excluir equipe',
    DeleteRateBtnTitle: 'Excluir permanentemente',
    Disable_Permission_Message: 'Você está prestes a desativar uma permissão em seu papel que permite editar suas próprias permissões e de outros usuários.',
    Disable_Permission_Title: 'Você não poderá mais editar as permissões do usuário.',
    DisplayName_customerId: 'Cliente',
    DisplayName_email: 'Email',
    DisplayName_hourlyRate: 'Taxa de faturamento por hora',
    DisplayName_hourlyRateInternal: 'Taxa interna por hora',
    DisplayName_login: 'Login',
    email: 'E-mail',
    exclude: 'Excluir',
    filterbystatus_Active: 'Somente ativos',
    filterbystatus_All: 'Ativos e inativos',
    filterbystatus_CannotLogin: 'Somente não podem fazer login',
    filterbystatus_Inactive: 'Somente inativos',
    generate: 'Gerar',
    guest_portal_title: 'Portal de visitantes.',
    guests_interaction: 'Os visitantes podem interagir com o sistema apenas via',
    guests_license: 'Eles não precisam de uma licença.',
    guests_users_tab_title: 'Visitantes',
    import_title: 'Importar',
    inactive: 'Inativo',
    jobroles_updated_successfully: 'As funções de cargo foram atualizadas com sucesso',
    lastActivityDate_title: 'Última visita',
    licensing_limits_warning: 'Você não pode permitir que esse usuário faça login porque sua licença não permite adicionar mais usuários que podem fazer login.',
    name_column_title: 'Nome',
    no_sercurity_logs: 'Este usuário ainda não possui entradas',
    password_changed: 'A senha foi alterada.',
    personal_schedule_title: 'Agenda pessoal',
    regular_users_tab_title: 'Regulares',
    reload: 'Atualizar',
    remove_confirm: 'Remover usuário?',
    reset: 'Atribuir',
    reset_password_confirmation: 'Ao clicar em \"Gerar\", uma nova senha será gerada e enviada por email ao usuário.',
    reset_password_done: 'Nova senha gerada e enviada.',
    reset_password_menu_title: 'Gerar e enviar senha',
    reset_password_title: 'Tem certeza de que deseja gerar e enviar a nova senha?',
    reset_permissions_confirmation: 'Depois de atribuídas, o usuário terá a função atual em todos os projetos em que ele é membro. A operação não pode ser desfeita.',
    reset_permissions_done: 'Função atual foi atribuída.',
    reset_permissions_menu: 'Atribuir função atual',
    reset_permissions_title: 'Deseja atribuir a função atual a todos os projetos do usuário?',
    security_logs_action: 'Ação',
    security_logs_date: 'Data',
    security_logs_modal_title: 'Registro de segurança para',
    security_logs_title: 'Registro de segurança',
    securitylog_msg_GuestConverted: 'Função alterada de Visitante para {0} por {1}.',
    securitylog_msg_LoginChanged: 'O login foi alterado pelo usuário {0}.',
    securitylog_msg_LoginChangedBySelf: 'O login foi alterado.',
    securitylog_msg_PasswordChanged: 'A senha foi alterada pelo usuário {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'A senha foi recuperada.',
    securitylog_msg_PasswordChangedBySelf: 'A senha foi alterada.',
    securitylog_msg_PasswordGenerated: 'Senha gerada pelo usuário {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'Senha gerada.',
    securitylog_msg_PasswordIncorrect: 'Senha incorreta.',
    securitylog_msg_RecoveryRequest: 'Pedido de recuperação.',
    securitylog_msg_RoleChanged: 'Função alterada de {0} para {1} por {2}.',
    securitylog_msg_UserLockout: 'Usuário foi bloqueado após tentativas de senha inválidas.',
    securitylog_msg_UserLockoutDueToInactivity: 'Usuário foi bloqueado devido à inatividade.',
    securitylog_msg_UserUnlocked: 'Usuário foi desbloqueado por {0}.',
    selected_users: '1#{0} Usuário selecionado#{0} Usuários selecionados',
    Set_skills: 'Adicionar habilidades',
    Set_teams: 'Equipes',
    show: 'Mostrar',
    show_other_reasons: 'Mostrar outros motivos',
    skills: 'Habilidades',
    skills_updated_successfully: 'Habilidades atualizadas com sucesso',
    skillsDeleteConfirm: 'A habilidade será removida dos perfis de outros usuários onde está sendo usada',
    suggest_deactivate: 'No entanto, você tem a opção de tornar o usuário inativo, o que removerá a visibilidade dele em toda a {brandName}, exceto na página de Usuários e no histórico de atribuições de projetos e tarefas. Essa ação liberará uma licença para outro usuário.',
    teams: 'Equipes',
    teams_updated_successfully: 'As equipes foram atualizadas com sucesso',
    teamsDeleteConfirm: 'A equipe será removida das equipes de cada usuário',
    TimerText: '1#{0} segundo#{0} segundos',
    unlock: 'Desbloquear',
    user_conversion_done: '{0} foi convertido com sucesso.',
    user_conversion_title: 'Conversão de usuário',
    user_duplicate_email_error: 'Um usuário com o e-mail especificado já existe',
    user_duplicate_login_error: 'Um usuário com o login especificado já existe',
    user_licensing_limits_warning: 'Você não pode ativar o Acesso ao sistema para este usuário, pois não há mais licenças disponíveis.',
    User_NotFound_Title: 'Usuário solicitado não encontrado',
    userRates: 'Histórico de taxas',
    userRates_date: 'Data da alteração',
    userRates_hourlyRate: 'Taxa de faturamento',
    userRates_hourlyRateInternal: 'Taxa interna',
    userRates_title: 'Histórico de taxas para {0}',
};
